export const backtoschool = {
  name: 'Back to School',
  color: [0.9803921568627451, 0.6823529411764706, 0.23921568627450981, 1],
  bg: [0.5058823529411764, 0.44313725490196076, 0.3686274509803922, 1],
  grid1: [0.9215686274509803, 0.5411764705882353, 0.26666666666666666, 1],
  grid2: [0.9176470588235294, 0.3254901960784314, 0.3686274509803922, 1],
}
